import { Skeleton, Spacer } from "@fullscript/aviary-web";

import * as styles from "./GoogleSSOButton.styles";

interface Props {
  isOrTextRendered?: boolean;
}
const SkeletonGoogleSSOButton = ({ isOrTextRendered }: Props) => {
  const skeletonOr = (
    <div css={styles.GoogleSSOButton}>
      <Skeleton variant="typography" typographyType="footnote" width={64} />
      <Spacer size="small" direction="horizontal" />
      <Skeleton variant="button" width={16} height={16} />
      <Spacer size="small" direction="horizontal" />
      <Skeleton variant="typography" typographyType="footnote" width={64} />
    </div>
  );

  if (isOrTextRendered) {
    return (
      <>
        <Spacer />
        <Skeleton variant="button" size="medium" width={160} />
        <Spacer />
        {skeletonOr}
        <Spacer />
      </>
    );
  }
};

export { SkeletonGoogleSSOButton };
